import {
  useEffect,
  useState,
} from 'react'
import { 
  useDispatch,
  useSelector,
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Text,
} from '@chakra-ui/react'

import { verifyEmail } from '../../features/auth/authSlice'


export default function EmailVerificationView() {

  const { isLoading, isError, isSuccess, message } = useSelector(
    (state) => state.auth
  )

  const [searchParams] = useSearchParams()
  const dispatch = useDispatch()

  const [isOpen, setIsOpen] = useState(true) // useDisclosure didn't work

  const verificationToken = searchParams.get("verificationToken")
  const email = searchParams.get("forEmail")

  useEffect(() => {
    if (verificationToken && email) {
      window.history.replaceState(null, "Account & preferences | TrainLookout", "/preferences")

      dispatch(verifyEmail({
        verificationToken: verificationToken,
        email: email,
      }))
    }
  }, [verificationToken, email, dispatch])

  if (verificationToken && email) {
    return (
      <>
        <Modal isOpen={isOpen}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Welcome to TrainLookout!</ModalHeader>
            <ModalBody>
              { isSuccess && (<Text>Email verified successfully</Text>)}
              { isError && (<Text>Error verifying email: {message}</Text>)}
            </ModalBody>

            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={() => setIsOpen(false)}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }
}
